var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.data
      ? _c("div", { staticClass: "parking-panel" }, [
          _c(
            "div",
            {
              staticClass: "parking-panel__close",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "10",
                    height: "10",
                    viewBox: "0 0 10 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0.232333 0.232333C-0.0774444 0.542111 -0.0774444 1.04436 0.232333 1.35414L3.8782 5L0.232333 8.64586C-0.0774444 8.95564 -0.0774444 9.45789 0.232333 9.76767C0.542111 10.0774 1.04436 10.0774 1.35414 9.76767L5 6.1218L8.64586 9.76767C8.95564 10.0774 9.45789 10.0774 9.76767 9.76767C10.0774 9.45789 10.0774 8.95564 9.76767 8.64586L6.1218 5L9.76767 1.35414C10.0774 1.04436 10.0774 0.542111 9.76767 0.232333C9.45789 -0.0774444 8.95564 -0.0774444 8.64586 0.232333L5 3.8782L1.35414 0.232333C1.04436 -0.0774444 0.542111 -0.0774444 0.232333 0.232333Z",
                      fill: "#2C2925",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "parking-panel__title" }, [
            _vm._v("Парковочное место №" + _vm._s(_vm.data.number)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "parking-panel__props" }, [
            _vm.data.price
              ? _c("span", [
                  _vm._v(_vm._s(_vm.formatPrice(_vm.data.price)) + " руб"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.priceOld
              ? _c("span", { staticClass: "parking-panel__props-through" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.formatPrice(_vm.data.priceOld)) +
                      " руб\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.area ? _c("span", [_vm._v("/")]) : _vm._e(),
            _vm._v(" "),
            _vm.data.area
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.replaceDotComma(_vm.data.area)) + " м. кв."
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "parking-panel__submit" }, [
            _c(
              "button",
              {
                staticClass: "button button_theme_color",
                on: {
                  click: function ($event) {
                    return _vm.$emit("submit", _vm.data)
                  },
                },
              },
              [_vm._v("Отправить заявку")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }